import { render, staticRenderFns } from "./listSessions.vue?vue&type=template&id=1de619bc&scoped=true&"
import script from "./listSessions.vue?vue&type=script&lang=js&"
export * from "./listSessions.vue?vue&type=script&lang=js&"
import style0 from "./listSessions.vue?vue&type=style&index=0&id=1de619bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de619bc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VContainer,VDataTable,VIcon,VProgressCircular,VProgressLinear,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Mihai Racoreanu\\Code\\bodyswaps\\bsportal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1de619bc')) {
      api.createRecord('1de619bc', component.options)
    } else {
      api.reload('1de619bc', component.options)
    }
    module.hot.accept("./listSessions.vue?vue&type=template&id=1de619bc&scoped=true&", function () {
      api.rerender('1de619bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/list-sessions/listSessions.vue"
export default component.exports